import { clone } from 'lodash';
import * as PIXI from 'pixi.js-legacy';
window.PIXI = PIXI;

class SpriteMaskSystem {
  constructor(systems) {
    this.systems = systems;
  }

  before(dt) {
  }

  after(dt) {
  }

  findShapeOrSprite(ent) {
    if (ent.sprite) {
      return (this.systems.spriteSystem.spriteCache[ent.uuid.uuid]||{}).sprite;
    }
    if (ent.shape) {
      return (this.systems.shapeCache[ent.uuid.uuid]||{}).shape;
    }
  }

  update(dt, ent) {

    const maskEnt = this.systems.getEntByTransformId(ent.spriteMask.maskTransformIds[0]);
    if (!maskEnt) {
      return;
    }

    //const maskContainer = this.systems.pixiContainers[maskEnt.uuid.uuid].inner;

    const outerContainer = this.systems.pixiContainers[ent.uuid.uuid].outer;
    const maskContainer = this.findShapeOrSprite(maskEnt);

    if (!outerContainer || !maskContainer) {
      return;
    }

    outerContainer.mask = maskContainer;
    //maskContainer.mask = outerContainer;

    this.systems.forceSetDirty(ent);
    this.systems.forceSetDirty(maskEnt);

    this.systems.removeComponent(ent, this.systems.Components.SpriteMask);
  }
}
export default SpriteMaskSystem;
